import { NavLink } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function Hero() {
  return (
    <section className="relative overflow-hidden bg-stone-950 min-h-[80vh] md:min-h-screen">
      <img
        src="https://brupa.it/cdn/shop/files/banner_home_spring_1a5a443f-7bfa-4bb2-adaa-e5838f21165b.png"
        alt="Brupa Fashion Mall"
        className="absolute inset-0 w-full h-full object-cover opacity-60"
      />
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-stone-950/90 via-stone-950/50 to-stone-950/10" />
      <div className="absolute inset-0 bg-gradient-to-t from-stone-950/60 via-transparent to-transparent" />

      <div className="relative flex items-center min-h-[80vh] md:min-h-screen">
        <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-12 w-full pt-16 md:pt-20 pb-10 md:pb-16">
          <div className="max-w-3xl">
            <p className="text-emerald-400 text-[10px] sm:text-[11px] tracking-[0.3em] uppercase mb-4 md:mb-8 font-semibold">
              Outlet Luxury · Fino al −70%
            </p>
            <h1
              className="text-white leading-[0.95] mb-5 md:mb-8"
              style={{ fontSize: "clamp(2.25rem, 8vw, 7rem)", fontWeight: 700, letterSpacing: "-0.03em" }}
            >
              Moda di<br />
              <span className="text-emerald-400">tendenza,</span><br />
              ogni giorno
            </h1>
            <p className="text-stone-300 text-sm md:text-lg leading-relaxed mb-6 md:mb-12 max-w-md">
              I migliori brand internazionali a prezzi outlet. Solo articoli selezionati.
            </p>
            <div className="flex flex-wrap gap-3 md:gap-4">
              <NavLink
                to="/donna"
                className="group inline-flex items-center gap-2 border border-white text-white text-[10px] sm:text-[11px] tracking-[0.25em] uppercase px-6 sm:px-10 py-3 sm:py-4 hover:bg-white hover:text-stone-900 transition-all duration-200 font-semibold"
              >
                Donna
                <ArrowRight className="size-3.5 group-hover:translate-x-1 transition-transform" />
              </NavLink>
              <NavLink
                to="/uomo"
                className="group inline-flex items-center gap-2 border border-white text-white text-[10px] sm:text-[11px] tracking-[0.25em] uppercase px-6 sm:px-10 py-3 sm:py-4 hover:bg-white hover:text-stone-900 transition-all duration-200 font-semibold"
              >
                Uomo
                <ArrowRight className="size-3.5 group-hover:translate-x-1 transition-transform" />
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
